import { MyEquipmentWarning, MyEquipmentLink } from '@cat-ecom/pcc-components';
import { CatButton } from 'components/blocks-components';
import { CatHeading } from 'blocks-nextjs/blocks-react/components/Heading';
import { useTranslations } from 'next-intl';
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';

type AddEquipmentDuplicateBannerProps = {
  onAccept: () => void;
  onCancel: () => void;
};
export const AddEquipmentDuplicateBanner = ({
  onAccept,
  onCancel
}: AddEquipmentDuplicateBannerProps) => {
  const t = useTranslations();
  return (
    <div className="mt-2 mb-2" data-testid="duplicate-banner-container">
      <MyEquipmentWarning
        errorNote={t('MEQ_DUPLICATE_EQUIPMENT_MESSAGE')}
        data-testid="duplicate-banner"
        variant="warning"
      >
        <>
          <CatIconWarningTriangle slot="before" />
          <CatHeading variant="body-sm">
            {t('MEQ_DUPLICATE_EQUIPMENT_SELECT')}
          </CatHeading>
          <div className="mt-2">
            <CatButton onClick={onAccept}>{t('YES')}</CatButton>
            <MyEquipmentLink className={''} onClick={onCancel}>
              {t('NO')}
            </MyEquipmentLink>
          </div>
        </>
      </MyEquipmentWarning>
    </div>
  );
};

export default AddEquipmentDuplicateBanner;
